import * as EventEmitter from "events";
import { IEventEmitter } from "../interfaces/IEventEmitter";

export default class MainMenu implements IEventEmitter {

    private icon:HTMLElement;
    private menu:HTMLElement;
    private overlay:HTMLElement;
    private eventEmitter:EventEmitter;

    constructor(icon: HTMLElement, menu: HTMLElement, overlay: HTMLElement) {
        this.icon = icon;
        this.menu = menu;
        this.overlay = overlay;
        this.eventEmitter = new EventEmitter();

        // set minimum height
        this.setMinimumHeight();

        this.icon.addEventListener('click', () => {
            if (this.icon.classList.contains('open')) {
                // Close menu
                this.icon.classList.remove('open');
                this.overlay.classList.remove('open');
                this.eventEmitter.emit(MenuEventType.Close);
                
            } else {
                // Open menu
                this.icon.classList.add('open');
                this.overlay.classList.add('open');
                this.eventEmitter.emit(MenuEventType.Open);
            }
        })
    }

    public on(eventType:string, func:(...args: any[]) => void) {
        this.eventEmitter.on(eventType, func);
    }

    private setMinimumHeight() {
        const menuComputedStyle = getComputedStyle(this.menu);
        const menuHeight = parseInt(menuComputedStyle.getPropertyValue('height'), 10);
        (this.overlay.querySelector('.menu-container') as HTMLElement).style.minHeight = menuHeight + "px";
    }
}

export const MenuEventType = {
    Open: "MenuEventType_open",
    Close: "MenuEventType_close",
}